const hasNotification = (state: AnyFixMe) => state.newReleases.hasNotification;

export { hasNotification };
